// extracted by mini-css-extract-plugin
module.exports = {"navBar":"FooterNavBar_navBar__2qwfc","navItem":"FooterNavBar_navItem__1OBDD","navLink":"FooterNavBar_navLink__3N53m"};